import React, { Component, Fragment } from 'react';
import { Container, Box, Typography } from '@mui/material';
import { withTranslation, WithTranslation } from 'react-i18next';
import ResponsiveAppBar from '../../components/components/appbar';
import ResponsiveFooter from '../../components/components/footer';

class PageNotFound extends Component<WithTranslation> {

    render() {
        const t = this.props.t;
        return (
            <Fragment>
                <ResponsiveAppBar />

                <Container className="pageHeight" maxWidth="xl" sx={{ my: 8 }}>
                    <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", my: 1, flexDirection: { xs: "column", md: "row" }, }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', }}>
                            <lord-icon trigger="loop" src="./assets/json/warning.json"
                                style={{ width: "200px", height: "200px" }} ></lord-icon>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', }}>
                            <Typography justifyContent="center"
                                alignItems="center" variant="h3" gutterBottom component="div" sx={{ my: 2 }} style={{ textAlign: "center" }}>
                                {t("pageNotFoundText")}
                            </Typography>
                        </Box>
                    </Box>
                </Container>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default withTranslation()(PageNotFound);